module.exports = __webpack_public_path__ + "static/media/gc-breakfast-bad.ff03c7eb.png";